module.exports = __FOREMAN_VENDOR__AXIOS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__AXIOS__"
// module id = axios
// module chunks = 0